<template>
  <div class="container d-flex fd-column SECTION">
    <div class="h3 text-bold p-x-1:mo p-b-2">
      <div>{{serviceTitle}}</div>
    </div>
    <div class="d-flex input-container">
      <div
          :class="{ 'input-message error': hasErrors && errorMessage }"
          :error="errorMessage"
          class="input-container p-b-3 fd-column">
        <input
            v-vk-input
            v-model="zipcode"
            type="tel"
            name="postal"
            autocomplete="postal-code"
            placeholder="Zipcode"
            visible-placeholder
            class="input ZIPCODE-INPUT"/>
        <button @click="submit" class="btn">Search Zipcode</button>
      </div>

    </div>
    <div class="d-flex w-100 fd-column:mo flex-0-1 SERVICE-SECTION" >
      <div
          v-for="(service, index) in services"
          :key="index"
          class="SERVICE"
          @click="handleServiceClick(index)"
      >
        <div class="d-flex fd-column ITEM p-b-2">
          <img
              class="IMAGE m-b-3"
              :src="getImage(service.display_name).image"
              :alt="getImage(service.display_name).altText"

          /><div class="h5 text-bold p-x-1:mo m-b-1 ">{{service.display_name}}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import { mapActions, mapGetters } from 'vuex';

const IMAGES = {
  carpenter: require('./assets/carpenter.jpg'),
  ceiling_fan_installation: require('./assets/ceiling_fan_installation.jpg'),
  deck_builder: require('./assets/deck_builder.jpg'),
  default: require('./assets/default_image.jpg'),
  electrician: require('./assets/electrician.jpg'),
  general_contractor: require('./assets/general_contractor.jpg'),
  handyman: require('./assets/handyman.jpg'),
  holiday_lighting_installation: require('./assets/holiday_lighting_installation.jpg'),
  painter: require('./assets/painter.jpg'),
  shed_assmembly: require('./assets/shed_assmembly.jpg'),
  shower_door_installation: require('./assets/shower_door_installation.jpg'),
  television_mount: require('./assets/television_mount.jpg'),

};
export default {
  name: 'trending-services',
  data () {
    return {
      topThree: [],
      zipError: false,
      apiError: false,
      noServicesError: false,
      displayZip: '',
      services: [],
    };
  },
  computed: {
    ...mapGetters('homepage/trending', ['nationalTrendingServices', 'trendingServices']),
    ...mapGetters('homepage/search', [
      'results',
    ]),

    serviceTitle () {
      return this.displayZip ? `Trending Services Now In ${this.displayZip}` : 'Trending Services';
    },
    zipcode: {
      get () {
        return this.$store.state.homepage.geo.zipcode;
      },
      set (value) {
        this.$store.commit('homepage/geo/updateZipcode', value);
        this.preventSubmission = false;
      },
    },
    invalidZipcode () {
      return !/^\d{5}$/.test(this.zipcode);
    },
    hasErrors () {
      return this.zipError || this.apiError || this.noServicesError;
    },
    errorMessage () {
      if (this.invalidZipcode) {
        return 'Please enter a valid zipcode.';
      }
      if (this.noServicesError) {
        return 'We’re sorry, we were unable to load trending services. Please try another ZIP Code.';
      }
      if (this.apiError) {
        return 'We’re sorry, we were unable to load trending services. Please reenter your ZIP Code and try again.';
      }
      return '';
    },
  },
  watch: {
    zipcode () {
      if (this.hasErrors) {
        this.clearErrors();
      }
    },
  },
  mounted () {
    this.services = this.nationalTrendingServices;
  },
  methods: {
    ...mapActions('homepage/trending', ['fetchTrendingServices']),

    submit () {
      this.preventSubmission = true;
      this.zipError = this.invalidZipcode;
      this.getTrendingServices();
    },
    async getTrendingServices () {
      if (this.invalidZipcode) {
        return;
      }
      try {
        await this.fetchTrendingServices(this.zipcode);
        if (this.trendingServices.length < 3) {
          this.noServicesError = true;
        } else {
          this.services = this.trendingServices;
          this.displayZip = this.zipcode;
        }
      } catch (err) {
        this.apiError = true;
        this.displayZip = '';
      } finally {
        this.$events.$emit(this.$events.TRENDING_SERVICES_ZIP_SEARCH,
          {
            zipcode: this.zipcode,
            results: this.hasErrors ? this.errorMessage : this.trendingServices,
          }
        );
      }
    },
    getImage (name) {
      switch (name.toLowerCase()) {
        case 'ceiling fan installation':
          return { image: IMAGES.ceiling_fan_installation, altText: 'contractor installing ceiling fan' };
        case 'holiday lighting installation':
          return { image: IMAGES.holiday_lighting_installation, altText: 'holiday Lighting image' };
        case 'light fixture installation':
          return { image: IMAGES.electrician, altText: 'contractor installing light fixture' };
        case 'carpentry framing':
        case 'deck or porch repair':
          return { image: IMAGES.carpenter, altText: 'contractor cutting wood' };
        case 'deck build':
          return { image: IMAGES.deck_builder, altText: 'contractor building deck' };
        case 'drywall/sheetrock installation':
        case 'vanity installation':
          return { image: IMAGES.general_contractor, altText: 'contractor installing drywall' };
        case 'shed assembly':
          return { image: IMAGES.shed_assmembly, altText: 'shed image' };
        case 'stock shower door installation':
          return { image: IMAGES.shower_door_installation, altText: 'shower door image' };
        case 'television mount':
          return { image: IMAGES.television_mount, altText: 'contractor installing television mount' };
        case 'fence repair':
        case 'gutter repair':
        case 'over the range microwave installation':
        case 'screen door installation':
        case 'screen repair':
        case 'window mounted ac installation':
          return { image: IMAGES.handyman, altText: 'contractor measuring wood' };
        case 'exterior painting':
        case 'interior painting':
          return { image: IMAGES.painter, altText: 'contractor painting interior walls' };

        default:
          return { image: IMAGES.default, altText: 'contractor speaking with homeowner' };
      }
    },
    clearErrors () {
      this.zipError = false;
      this.apiError = false;
      this.noServicesError = false;
    },
    handleServiceClick (index) {
      const { display_name } = this.services[index];
      this.$store.dispatch('homepage/search/searchForServices', {
        query: display_name,
        size: 1,
      })
        .then(() => {
          this.$store.commit('homepage/request/setSelectedService', this.results[0]);
          this.$store.dispatch('homepage/search/reset');
          this.$events.$emit(this.$events.TRENDING_SERVICES_CLICK,
            {
              serviceClicked: display_name,
            }
          );
        });
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@homeservices/design-kit/tools";
  .SECTION {
    margin-bottom: 8 * $unit;
  }
  .SERVICE-SECTION {
    display: flex;
    flex: 1 1 auto;
  }
  .SERVICE {
    @include desktop () {
      margin-right: 16px;
      cursor: pointer;
    }
  }
  .SERVICE:nth-child(3) {
    margin-right: 0px;
  }
  .ITEM {
    max-width: 395px;
    text-align: left;
  }
  .IMAGE {
    align-self: auto;
    max-width:100%;
    height: auto;
  }
  .ZIPCODE-INPUT {
    height: 44px;
    max-width: 200px;;
    margin: 0px 20px 0px 0px;
    padding-left: 20px;
    padding-top: 4px;
    text-align: left;
  }
  .ERROR-MESSAGE {
    background-color: $color-red;
    @include margin-bottom(1);
    @include margin-x(1);
    @include padding(2);
    text-align: center;
    color: white;
    @include tablet() {
      position: absolute;
      margin-top: -$unit;
      margin-left: 0;
    }
  }
</style>
